export const taskQueryKeys = {
  all: ['task'],
  details: ['task', 'details'],
  detail: (taskId) => ['task', 'detail', taskId],
};
